import {
    Component,
    OnInit
} from '@angular/core';
import { Breadcrumb } from '../shared/components';
import { RolesEnum } from '../core/auth/roles';
import { skip } from 'rxjs';
import { AuthService } from '../core/auth/auth.service';
import { R } from '@angular/cdk/overlay.d-BdoMy0hX';

@Component({
    selector: 'app-relatorio',
    templateUrl: './relatorio.component.html',
    standalone: false
})
export class RelatorioComponent implements OnInit {

    breadcrumb: Breadcrumb[] = [
        { label: 'Início' },
        { label: 'Relatórios' },
    ]

    filteredRelatorios: any[];
    currentRole: string;

    /**
     * Historia para relatorios do coordenador: https://trello.com/c/EySx7re8
     */

    relatorios: any = [
        {
            titulo: 'DIO\'s Não Executados',
            routerLink: 'dio-nao-executado',
            descricao: 'Relatório de diário de operações não executados por contratos.',
            skipRoles: [RolesEnum.COORDENADOR]
        }, {
            titulo: 'Consumo por Equipamento',
            routerLink: 'consumo-por-equipamento',
            descricao: 'Relatório de consumo por equipamento',
            skipRoles: [RolesEnum.COORDENADOR, RolesEnum.EMISSOR]
        }, {
            titulo: 'Valores Brutos por Beneficiários',
            routerLink: 'valor-bruto-beneficiario',
            descricao: 'Relatório de valores a serem pagos por tipo de tarifação (maquina ou veículo) de um determinado contrato em um período.',
            skipRoles: [RolesEnum.COORDENADOR, RolesEnum.EMISSOR]
        }, {
            titulo: 'Valores Monetário Brutos',
            routerLink: 'valor-bruto-monetario',
            descricao: 'Relatório de valores brutos monetários de diário de operações.',
            skipRoles: [RolesEnum.COORDENADOR, RolesEnum.EMISSOR]
        }, {
            titulo: 'Equipamentos Existentes',
            routerLink: 'equipamentos-existentes',
            descricao: 'Relatório com o status dos equipamentos/veículos cadastrados.',
            skipRoles: [RolesEnum.COORDENADOR, RolesEnum.EMISSOR]
        }, {
            titulo: 'Valores Brutos Por Equipamentos',
            routerLink: 'valores-brutos-equipamentos',
            descricao: 'Relatório com o valor a ser pago por equipamentos.',
            skipRoles: [RolesEnum.COORDENADOR, RolesEnum.EMISSOR]
        }, {
            titulo: 'Aferições Por Período',
            routerLink: 'relatorio-afericoes',
            descricao: 'Relatório quantativo de DIOs com status Pendentes de Aferição e Aferidas.',
            skipRoles: [RolesEnum.COORDENADOR, RolesEnum.EMISSOR]
        }, {
            titulo: 'Relatório DIOs Aferidas',
            routerLink: 'relatorio-dios-aferidas',
            descricao: 'Relatório de DIOs Aferidas por período.',
            skipRoles: [RolesEnum.EMISSOR]
        }, {
            titulo: 'Relatório Aferições por Aferidores',
            routerLink: 'relatorio-afericoes-aferidores',
            descricao: 'Relatório para exibir a quantidade de aferições atribuídas a cada aferidor.',
            skipRoles: [RolesEnum.EMISSOR]
        }, {
            titulo: 'Aprovações Realizadas',
            routerLink: 'aprovacoes',
            descricao: 'Relatório o resumos das aprovações realizadas.',
            skipRoles: [RolesEnum.EMISSOR, RolesEnum.COORDENADOR]
        }, {
            titulo: 'Prefixos sem DIOs',
            routerLink: 'prefixos-sem-dios',
            descricao: 'Relatório para exibir os prefixos que não possuem DIOs cadastrados em determinada data.',
            skipRoles: [RolesEnum.COORDENADOR]
        }, {
            titulo: 'DIOs Por Prefixo',
            routerLink: 'dios-por-prefixo',
            descricao: 'Relatório para exibir os DIOs por prefixo.',
            skipRoles: [RolesEnum.EMISSOR, RolesEnum.COORDENADOR]
        }, {
            titulo: 'Usuários por Beneficiária',
            routerLink: 'usuarios-por-beneficiaria',
            descricao: 'Relatório para exibir a listagem de usuários associados a uma beneficiária.',            
            skipRoles: [RolesEnum.EMISSOR, RolesEnum.COORDENADOR]
        }, {
            titulo: 'Pendências de Faturamento',
            routerLink: 'pendencias-de-faturamento',
            descricao: 'Relatório para exibir as pendências de faturamento por contrato.',
            skipRoles: [RolesEnum.EMISSOR, RolesEnum.COORDENADOR]
        }, {
            titulo: 'Dashboard Beneficiária',
            routerLink: 'dashboard-beneficiaria',
            descricao: 'Dashboard com prefixos da beneficiária separados por status: aguardando execução, cancelados e sem DIOs abertos.',
            skipRoles: [RolesEnum.EMISSOR]
        }, {
            titulo: 'DIOs Encerrados Automaticamente',
            routerLink: 'dios-encerrados-automaticamente',
            descricao: 'Relatório com prefixos e quantidade de DIOs encerrados automaticamente em um período.',
            skipRoles: [RolesEnum.EMISSOR, RolesEnum.COORDENADOR]
        },
    ]

    constructor(
        private authService: AuthService
    ){}

    ngOnInit() {
        this.filteredRelatorios = this.relatorios;
        this.currentRole = this.authService.user.realm_access.roles[0];
    }

    filter(term: string) {
        if (!term || term === '') {
            this.filteredRelatorios = Object.assign([], this.relatorios);
        }
        this.filteredRelatorios = Object.assign([],
            this.relatorios).filter((item: any) =>
                item.titulo.toLowerCase().indexOf(term.toLowerCase()) > -1 ||
                item.descricao.toLowerCase().indexOf(term.toLowerCase()) > -1
            );
    }

    showReportByRoles(skipRoles: RolesEnum[]) {
        const currentRoleEnum = RolesEnum[this.currentRole as keyof typeof RolesEnum];
        return !skipRoles.includes(currentRoleEnum);
    }

}
